var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#104fca",
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 9.568l4.234 7.103V24C8.896 24 7 22.164 7 19.899z",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.765 16.663l4.232-7.099h.002V19.9C25 22.164 23.104 24 20.765 24z",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.997 16.458L13.88 20.01c-.439-.11-.911-.536-1.416-1.277L7 9.568c2.025-1.133 4.615-.46 5.784 1.5z",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.216 11.06C20.385 9.098 22.975 8.426 25 9.559l-5.464 9.165A4.267 4.267 0 0116 20.568a4.33 4.33 0 01-1.9-.435l-.22-.123z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMth);
export default __webpack_public_path__ + "static/media/mth.f76e7f246b10f2c0a9aca418920b8c9a.svg";
export { ForwardRef as ReactComponent };